import React from "react";
import { FaExclamationTriangle, FaSeedling } from "react-icons/fa";

import { formatRate, isOutOfTarget } from "./fieldAppInputRefillUtils";

function formatDateTime(value) {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleString("pt-BR");
  } catch (error) {
    return String(value);
  }
}

function RateCell({ actual, target, unit }) {
  const outOfTarget = isOutOfTarget(actual, target);
  return (
    <td className={outOfTarget ? "field-app-inputs-alert" : ""}>
      {formatRate(actual, unit)}
      {outOfTarget ? (
        <FaExclamationTriangle
          title="Fora da taxa-alvo"
          style={{ marginLeft: 6 }}
        />
      ) : null}
    </td>
  );
}

function FieldAppInputsPanel({ groups, loading, t }) {
  if (loading) {
    return (
      <p className="field-app-intro field-app-intro--compact">{t("Carregando...")}</p>
    );
  }

  return (
    <div className="field-app-inputs">
      <p className="field-app-intro field-app-intro--compact">
        {t(
          "Mesma função Insumos a cada abastecimento do app: cada trabalho (plantio ou aplicação) com paradas registradas e dosagem por hectare de adubo, semente ou defensivo."
        )}
      </p>

      {groups.length === 0 ? (
        <div className="field-app-empty-panel">
          {t(
            "Nenhum trabalho de insumos recebido ainda. O operador registra no app a cada abastecimento ou descarga na base."
          )}
        </div>
      ) : (
        groups.map((group) => {
          const { work, refills } = group;
          const isPlanting =
            String(work.operationType).toLowerCase().indexOf("plant") >= 0 ||
            String(work.operationType).toLowerCase().indexOf("plantio") >= 0;

          return (
            <section key={work.key} className="field-app-inputs-work">
              <header className="field-app-inputs-work-header">
                <div>
                  <h4>
                    <FaSeedling style={{ marginRight: 8 }} />
                    {work.name}
                  </h4>
                  <p>
                    {work.operationType}
                    {work.machineName ? ` · ${work.machineName}` : ""}
                    {work.operatorName ? ` · ${work.operatorName}` : ""}
                  </p>
                </div>
                <div className="field-app-inputs-targets">
                  {work.targetFertilizer != null ? (
                    <span>
                      {t("Adubo alvo")}: {formatRate(work.targetFertilizer, "kg/ha")}
                    </span>
                  ) : null}
                  {work.targetSeed != null ? (
                    <span>
                      {t("Semente alvo")}: {formatRate(work.targetSeed, "kg/ha")}
                    </span>
                  ) : null}
                  {work.targetPesticide != null ? (
                    <span>
                      {t("Defensivo alvo")}: {formatRate(work.targetPesticide, "L/ha")}
                    </span>
                  ) : null}
                </div>
              </header>

              {refills.length === 0 ? (
                <p className="field-app-inputs-empty">
                  {t("Trabalho iniciado — aguardando paradas de abastecimento.")}
                </p>
              ) : (
                <div className="table-responsive">
                  <table className="table table-striped jambo_table field-app-inputs-table">
                    <thead>
                      <tr>
                        <th>{t("Data")}</th>
                        <th>{t("Operador")}</th>
                        <th>{t("Ha trecho")}</th>
                        <th>{t("Horímetro")}</th>
                        {(isPlanting || work.targetFertilizer != null) && (
                          <>
                            <th>{t("Adubo (kg)")}</th>
                            <th>{t("Adubo kg/ha")}</th>
                          </>
                        )}
                        {(isPlanting || work.targetSeed != null) && (
                          <>
                            <th>{t("Semente (kg)")}</th>
                            <th>{t("Semente kg/ha")}</th>
                          </>
                        )}
                        {(!isPlanting || work.targetPesticide != null) && (
                          <>
                            <th>{t("Defensivo (L)")}</th>
                            <th>{t("Defensivo L/ha")}</th>
                          </>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {refills.map((refill) => (
                        <tr key={refill.uuid}>
                          <td>{formatDateTime(refill.recordedAt)}</td>
                          <td>{refill.operatorName}</td>
                          <td>{formatRate(refill.hectares, "ha")}</td>
                          <td>{formatRate(refill.hourMeter, "h")}</td>
                          {(isPlanting || work.targetFertilizer != null) && (
                            <>
                              <td>{formatRate(refill.fertilizerKg, "kg")}</td>
                              <RateCell
                                actual={refill.fertilizerKgHa}
                                target={
                                  refill.targetFertilizer != null
                                    ? refill.targetFertilizer
                                    : work.targetFertilizer
                                }
                                unit="kg/ha"
                              />
                            </>
                          )}
                          {(isPlanting || work.targetSeed != null) && (
                            <>
                              <td>{formatRate(refill.seedKg, "kg")}</td>
                              <RateCell
                                actual={refill.seedKgHa}
                                target={
                                  refill.targetSeed != null
                                    ? refill.targetSeed
                                    : work.targetSeed
                                }
                                unit="kg/ha"
                              />
                            </>
                          )}
                          {(!isPlanting || work.targetPesticide != null) && (
                            <>
                              <td>{formatRate(refill.pesticideL, "L")}</td>
                              <RateCell
                                actual={refill.pesticideLHa}
                                target={
                                  refill.targetPesticide != null
                                    ? refill.targetPesticide
                                    : work.targetPesticide
                                }
                                unit="L/ha"
                              />
                            </>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </section>
          );
        })
      )}
    </div>
  );
}

export default FieldAppInputsPanel;
